import { Navigate, createFileRoute } from "@tanstack/react-router";

import { useAvailableVenuesQuery } from "../hooks/venues";

const IndexComponent = () => {
  const venuesQuery = useAvailableVenuesQuery();

  if (venuesQuery.data && venuesQuery.data[0]) {
    return (
      <Navigate
        to={`/gym/$venueUuid/routes/$climbType`}
        params={{
          venueUuid: venuesQuery.data[0].uuid,
          climbType: "boulder",
        }}
        search={{ tab: "maps" }}
        replace
      />
    );
  }
};

export const Route = createFileRoute("/")({
  component: IndexComponent,
});
